import { useState, useEffect } from "react";
import { Loader2 } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function HealthGate({ children }) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    let attempts = 0;

    const check = async () => {
      try {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 3000);
        const res = await fetch(`${API}/api/health`, { signal: controller.signal });
        clearTimeout(timeout);
        if (!cancelled && res.ok) {
          setReady(true);
          return;
        }
      } catch (_) {}
      attempts++;
      if (!cancelled && attempts < 15) {
        setTimeout(check, attempts <= 3 ? 500 : 1000);
      } else if (!cancelled) {
        setReady(true);
      }
    };

    check();
    return () => { cancelled = true; };
  }, []);

  if (ready) return children;

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center space-y-4">
        <Loader2 className="w-8 h-8 animate-spin text-muted-foreground mx-auto" />
        <p className="text-sm text-muted-foreground tracking-wide">Preparing your experience…</p>
      </div>
    </div>
  );
}
